import React from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from 'components/ui/dialog'
import { Button } from 'components/ui/button'
import { IMAGE_RETENTION_DAYS, imageDeleteNotice } from 'constants/imageRetention'
import { TriangleAlert } from 'lucide-react'

interface ImageDeleteConfirmProps {
	open: boolean
	onClose: () => void
	onConfirm: () => void
}

const ImageDeleteConfirm: React.FC<ImageDeleteConfirmProps> = ({ open, onClose, onConfirm }) => {
	return (
		<Dialog open={open} onClose={onClose}>
			<DialogContent className="max-w-sm p-6">
				<DialogHeader>
					<div className="flex items-center gap-3">
						<div className="w-10 h-10 rounded-lg flex items-center justify-center bg-red-100 text-red-600">
							<TriangleAlert className="w-5 h-5" />
						</div>
						<div>
							<DialogTitle>Remove Image</DialogTitle>
							<DialogDescription>Recoverable for {IMAGE_RETENTION_DAYS} days</DialogDescription>
						</div>
					</div>
				</DialogHeader>
				<div className="flex flex-col items-center text-center gap-4">
					<div>
						{/*
							This used to say "This action cannot be undone... permanently
							remove". Both halves were wrong in opposite directions: the row
							was only soft-deleted so it never truly went, and the stored
							file was never destroyed at all, so the picture stayed
							fetchable at its public URL forever.

							Now it says what actually happens, and the second sentence is
							the part that was never true before. See MYD-463.
						*/}
						<p className="mt-2 text-sm text-gray-600">{imageDeleteNotice()}</p>
					</div>
					<div className="flex gap-3 w-full mt-2">
						<Button
							variant="ghost"
							className="flex-1"
							onClick={onClose}
						>
							Cancel
						</Button>
						<Button
							variant="danger"
							className="flex-1"
							onClick={onConfirm}
						>
							Remove Image
						</Button>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	)
}

export default ImageDeleteConfirm
